import * as z from "zod";
import { AdvancedFilterDataSchema } from "../views/views";

export const enRouteInventoryFilterNames = [
  "returnsCenterId",
  "status",
  "teamId",
] as const;

export type EnRouteInventoryFilterName =
  (typeof enRouteInventoryFilterNames)[number];

export const EnRouteInventoryFiltersInputSchema = z.object({
  advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
});

export type EnRouteInventoryFiltersInput = z.infer<
  typeof EnRouteInventoryFiltersInputSchema
>;
